import _classCallCheck from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/drone/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component, Fragment } from 'react';
import Head from 'next/head';
import Router from 'next/router';
import NProgress from 'nprogress';
import PropTypes from 'prop-types';
import { hotjar } from 'react-hotjar';
import LayoutProps from "../../state/utils/layout-props";
import { getParam } from "../../state/utils/remote-config";
import { ENV, HOTJAR_ID, endpoints } from "../../state/utils/config";
import { getCurrentLang } from "../../state/utils/i18n";
import { basePath } from "../../shared/constants/RoutesPaths";
NProgress.configure({
  minimum: 0.8,
  speed: 500
});
Router.custom.onRouteChangeStart(function () {
  return NProgress.start();
});
Router.custom.onRouteChangeComplete(function () {
  return NProgress.done();
});
Router.custom.onRouteChangeError(function () {
  return NProgress.done();
});
var Layout = /*#__PURE__*/function (_Component) {
  _inherits(Layout, _Component);
  var _super = _createSuper(Layout);
  function Layout() {
    _classCallCheck(this, Layout);
    return _super.apply(this, arguments);
  }
  _createClass(Layout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.onerror = function (msg, url, lineNo, columnNo, error) {
        console.error(msg, url, error);
      };
      this.initializeHotjar();
    }
  }, {
    key: "initializeHotjar",
    value: function initializeHotjar() {
      var enabled_production = Boolean(getParam('enable_hotjar_production_web')) && ENV === 'production';
      var enabled_staging = Boolean(getParam('enable_hotjar_staging_web')) && ENV === 'staging';
      if ((enabled_production || enabled_staging) && HOTJAR_ID) {
        hotjar.initialize(HOTJAR_ID, 6);
      }
    }
  }, {
    key: "getCanonicalUrl",
    value: function getCanonicalUrl() {
      var path = this.props.path;
      if (path && path !== 'undefined') {
        return endpoints.APP + path;
      }
      return "".concat(endpoints.APP, "/").concat(getCurrentLang()).concat(basePath);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        page = _this$props.page,
        data = _this$props.data;
      var url = this.getCanonicalUrl();
      var SEO = LayoutProps.get(page, data);
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("title", {
        key: "title"
      }, SEO.title), /*#__PURE__*/React.createElement("meta", {
        key: "description",
        name: "description",
        content: SEO.description
      }), /*#__PURE__*/React.createElement("meta", {
        key: "abstract",
        name: "abstract",
        content: SEO.description
      }), /*#__PURE__*/React.createElement("meta", {
        key: "keywords",
        name: "keywords",
        content: SEO.keywords
      }), /*#__PURE__*/React.createElement("meta", {
        key: "author",
        name: "author",
        content: SEO.og.author
      }), /*#__PURE__*/React.createElement("meta", {
        key: "og:url",
        property: "og:url",
        content: url
      }), /*#__PURE__*/React.createElement("meta", {
        key: "og:type",
        property: "og:type",
        content: SEO.og.type
      }), /*#__PURE__*/React.createElement("meta", {
        key: "og:title",
        property: "og:title",
        content: SEO.og.title
      }), /*#__PURE__*/React.createElement("meta", {
        key: "og:description",
        property: "og:description",
        content: SEO.og.description
      }), /*#__PURE__*/React.createElement("meta", {
        key: "og:image",
        property: "og:image",
        content: SEO.og.image
      }), /*#__PURE__*/React.createElement("meta", {
        key: "og:image:type",
        property: "og:image:type",
        content: "image/jpeg"
      }), /*#__PURE__*/React.createElement("meta", {
        key: "og:image:width",
        property: "og:image:width",
        content: "210"
      }), /*#__PURE__*/React.createElement("meta", {
        key: "og:image:height",
        property: "og:image:height",
        content: "210"
      }), /*#__PURE__*/React.createElement("meta", {
        key: "theme-color",
        name: "theme-color",
        content: SEO.color
      }), /*#__PURE__*/React.createElement("meta", {
        key: "msapplication-TileColor",
        name: "msapplication-TileColor",
        content: SEO.color
      }), /*#__PURE__*/React.createElement("link", {
        key: "canonical",
        rel: "canonical",
        href: url
      })), children);
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        children: PropTypes.node,
        page: PropTypes.string,
        data: PropTypes.object,
        me: PropTypes.object,
        path: PropTypes.string
      };
    }
  }]);
  return Layout;
}(Component);
export { Layout as default };